"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidationError = exports.isCaptchaError = exports.isLoginCaptchaError = exports.objectKeysToDotNotation = exports.toDotNotation = exports.fromDotNotation = exports.newAmsResponseData = exports.newAmsResponseRawBody = exports.newAmsFetch = exports.refreshCsrfToken = exports.sendRequest = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _queryString = _interopRequireDefault(require("query-string"));

var _object = require("./object.js");

var _errors = require("../errors/errors.js");

var _http = require("./http.js");

var _async = require("./async.js");

// response.headers is an instance of Headers and not an object!
// Therefore you cannot use objectPath to get the `get` function
var getHeader = function getHeader(response, headerName) {
  return response && response.headers && response.headers.get(headerName);
};

var sendRequest = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(request, context) {
    var fetch, now, config, state, queryString, path, contentType, response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(request.body && !request.contentType)) {
              _context.next = 2;
              break;
            }

            throw new Error("sendRequest: contentType is required when body is defined. Request: ".concat(JSON.stringify(request)));

          case 2:
            fetch = context.fetch, now = context.now, config = context.config, state = context.state;
            queryString = _queryString["default"].stringify(request.query);
            path = queryString ? request.path + "?" + queryString : request.path;
            contentType = request.contentType || _http.contentTypes.none;
            _context.next = 8;
            return fetch("".concat(config.amsBaseUrl, "/").concat(path), {
              method: request.method,
              credentials: "include",
              headers: {
                "AMS-API-KEY": config.amsApiKey,
                "Content-Type": contentType.header,
                "X-CSRF-TOKEN": state.csrfToken
              },
              body: contentType.stringify(request.body)
            });

          case 8:
            response = _context.sent;

            if (request.invalidatesCsrfToken) {
              state.csrfToken = undefined;
            } else if (request.method === "POST") {
              state.csrfToken = getHeader(response, "x-csrf-token");
            }

            state.lastResponseTime = now();

            if (response.ok) {
              _context.next = 15;
              break;
            }

            _context.next = 14;
            return (0, _errors.newApiError)(request, response);

          case 14:
            throw _context.sent;

          case 15:
            return _context.abrupt("return", response);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.sendRequest = sendRequest;

var refreshCsrfToken = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(context) {
    var fetch, now, config, state, response, csrfToken;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetch = context.fetch, now = context.now, config = context.config, state = context.state;
            _context2.next = 3;
            return fetch("".concat(config.amsBaseUrl, "/get-csrf"), {
              method: "GET",
              credentials: "include",
              headers: {
                "AMS-API-KEY": config.amsApiKey
              }
            });

          case 3:
            response = _context2.sent;
            csrfToken = getHeader(response, "x-csrf-token");

            if (!csrfToken) {
              _context2.next = 12;
              break;
            }

            state.csrfToken = csrfToken;
            state.lastResponseTime = now(); // We need to consume the response

            _context2.next = 10;
            return response.text();

          case 10:
            _context2.next = 13;
            break;

          case 12:
            state.csrfTokenFailure = true;

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function refreshCsrfToken(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.refreshCsrfToken = refreshCsrfToken;

var newAmsFetch = function newAmsFetch(_ref3) {
  var fetch = _ref3.fetch,
      config = _ref3.config,
      _ref3$now = _ref3.now,
      now = _ref3$now === void 0 ? Date.now : _ref3$now;
  var IDLE_TIMEOUT = 10 * 60 * 1000;
  var state = {
    isBlocking: false,
    lastResponseTime: undefined,
    csrfTokenFailure: false,
    deferedQueue: (0, _async.newDeferedQueue)(),
    promiseChain: (0, _async.newPromiseChain)()
  };
  var context = {
    fetch: fetch,
    now: now,
    config: config,
    state: state
  };

  var amsFetch = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(request) {
      var response;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!state.csrfTokenFailure) {
                _context3.next = 4;
                break;
              }

              throw new Error("Failed to obtain CSRF token");

            case 4:
              if (!state.isBlocking) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", state.deferedQueue.enqueue(request));

            case 8:
              if (!(!state.csrfToken || !state.lastResponseTime || state.lastResponseTime < now() - IDLE_TIMEOUT)) {
                _context3.next = 21;
                break;
              }

              _context3.prev = 9;
              state.isBlocking = true;
              response = state.deferedQueue.enqueue(request);
              _context3.next = 14;
              return refreshCsrfToken(context);

            case 14:
              return _context3.abrupt("return", response);

            case 15:
              _context3.prev = 15;
              state.isBlocking = false;
              state.deferedQueue.process(amsFetch);
              return _context3.finish(15);

            case 19:
              _context3.next = 28;
              break;

            case 21:
              if (!(request.method === "POST")) {
                _context3.next = 27;
                break;
              }

              _context3.next = 24;
              return refreshCsrfToken(context);

            case 24:
              return _context3.abrupt("return", state.promiseChain.append(function () {
                return sendRequest(request, context);
              }));

            case 27:
              return _context3.abrupt("return", sendRequest(request, context));

            case 28:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9,, 15, 19]]);
    }));

    return function amsFetch(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  return amsFetch;
};

exports.newAmsFetch = newAmsFetch;

var newAmsResponseRawBody = function newAmsResponseRawBody(amsFetch) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(request) {
      var response;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return amsFetch(request);

            case 2:
              response = _context4.sent;
              _context4.prev = 3;
              _context4.next = 6;
              return response.json();

            case 6:
              return _context4.abrupt("return", _context4.sent);

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              return _context4.abrupt("return", undefined);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 9]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.newAmsResponseRawBody = newAmsResponseRawBody;

var newAmsResponseData = function newAmsResponseData(amsFetch) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(request) {
      var body;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return newAmsResponseRawBody(amsFetch)(request);

            case 2:
              body = _context5.sent;
              return _context5.abrupt("return", body.data);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.newAmsResponseData = newAmsResponseData;

var fromDotNotation = function fromDotNotation(string) {
  return string.replace(/\./g, ":");
};

exports.fromDotNotation = fromDotNotation;

var toDotNotation = function toDotNotation(string) {
  return string.replace(/:/g, ".");
};

exports.toDotNotation = toDotNotation;

var objectKeysToDotNotation = function objectKeysToDotNotation(object) {
  return (0, _object.mapKeys)(object, toDotNotation);
};

exports.objectKeysToDotNotation = objectKeysToDotNotation;

var isLoginCaptchaError = function isLoginCaptchaError(error) {
  return error.status === 403 && error.responseData.captchaSiteKey !== undefined;
};

exports.isLoginCaptchaError = isLoginCaptchaError;

var isCaptchaError = function isCaptchaError(error) {
  var _error$responseData;

  return error.status === 401 && ((_error$responseData = error.responseData) === null || _error$responseData === void 0 ? void 0 : _error$responseData.exceptionType) === "ReCaptchaException";
};

exports.isCaptchaError = isCaptchaError;

var isValidationError = function isValidationError(error) {
  return error.status === 500 && error.responseData.exceptionType === "ProcessingException" && Boolean(error.responseData.data) && Object.keys(error.responseData.data).filter(function (key) {
    return key !== ".";
  }).length > 0;
};

exports.isValidationError = isValidationError;